module.exports = __webpack_public_path__ + "media/images/logos/idnow-app-cbc4d83d9a6de469968ab70105f47a2f.png";